import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function DataCatalog() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Help / Data Catalog";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <h1>Data Catalog</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default DataCatalog;
